// extracted by mini-css-extract-plugin
export var portfolio = "projects-module--portfolio--I0qeS";
export var header = "projects-module--header--23xNi";
export var projects = "projects-module--projects--RoR2i";
export var project = "projects-module--project--1zdcJ";
export var thumb = "projects-module--thumb--1NIhJ";